import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const TL = (v) => new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',minimumFractionDigits:0}).format(v||0);

function SatisModal({ stokKalemleri, ogrenciler, onSave, onClose }) {
  const [form, setForm] = useState({ ogrenci_id:'', odeme_yontemi:'nakit', teslim_tarihi:'', notlar:'' });
  const [seciliKalemler, setSeciliKalemler] = useState([]);
  const [saving, setSaving] = useState(false);

  const kalemEkle = (kalemId) => {
    const k = stokKalemleri.find(s=>String(s.id)===kalemId);
    if (!k) return;
    if (seciliKalemler.find(s=>s.id===k.id)) return;
    setSeciliKalemler(prev=>[...prev, { ...k, miktar:'1', birim_fiyat: k.satis_fiyati||k.birim_maliyet||'' }]);
  };

  const kalemGuncelle = (idx, field, val) => {
    setSeciliKalemler(prev=>prev.map((k,i)=>i===idx?{...k,[field]:val}:k));
  };

  const kalemSil = (idx) => setSeciliKalemler(prev=>prev.filter((_,i)=>i!==idx));

  const toplam = seciliKalemler.reduce((s,k)=>s+(parseFloat(k.miktar||0)*parseFloat(k.birim_fiyat||0)),0);

  const handleSubmit = async () => {
    if (!form.ogrenci_id) { toast.error('Öğrenci seçin'); return; }
    if (!seciliKalemler.length) { toast.error('En az bir ürün ekleyin'); return; }
    setSaving(true);
    try {
      await onSave({
        ...form,
        kalemler: seciliKalemler.map(k=>({ stok_kalem_id:k.id, miktar:k.miktar, birim_fiyat:k.birim_fiyat }))
      });
    } finally { setSaving(false); }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{maxWidth:640}} onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">🛒 Yeni Materyal Satışı</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="muh-grid-2" style={{marginBottom:16}}>
          <div className="form-group"><label className="form-label">Öğrenci *</label>
            <select className="form-input" value={form.ogrenci_id} onChange={e=>setForm(f=>({...f,ogrenci_id:e.target.value}))}>
              <option value="">Seçin</option>
              {ogrenciler.map(o=><option key={o.id} value={o.id}>{o.ad} {o.soyad}</option>)}
            </select>
          </div>
          <div className="form-group"><label className="form-label">Ödeme Yöntemi</label>
            <select className="form-input" value={form.odeme_yontemi} onChange={e=>setForm(f=>({...f,odeme_yontemi:e.target.value}))}>
              <option value="nakit">Nakit</option><option value="kredi_karti">Kredi Kartı</option>
              <option value="banka_havalesi">Banka Havalesi</option><option value="taksit">Taksit</option>
            </select>
          </div>
        </div>

        {/* Ürün ekle */}
        <div style={{marginBottom:12}}>
          <div style={{fontWeight:700,marginBottom:8}}>Ürünler</div>
          <select className="form-input" onChange={e=>{kalemEkle(e.target.value);e.target.value='';}}>
            <option value="">+ Ürün ekle...</option>
            {stokKalemleri.filter(k=>k.stok_miktari>0).map(k=>(
              <option key={k.id} value={k.id}>{k.ad} (Stok: {k.stok_miktari} {k.birim}) — {TL(k.satis_fiyati)}</option>
            ))}
          </select>
        </div>

        {seciliKalemler.length > 0 && (
          <div style={{border:'1px solid var(--border)',borderRadius:10,overflow:'hidden',marginBottom:16}}>
            {seciliKalemler.map((k,i)=>(
              <div key={i} style={{display:'flex',gap:10,padding:'10px 14px',borderBottom:i<seciliKalemler.length-1?'1px solid var(--border)':'none',alignItems:'center'}}>
                <div style={{flex:1,fontWeight:600,fontSize:'0.875rem'}}>{k.ad}</div>
                <div className="form-group" style={{margin:0,width:80}}>
                  <input className="form-input" type="number" min="1" value={k.miktar} onChange={e=>kalemGuncelle(i,'miktar',e.target.value)} style={{textAlign:'center'}} />
                </div>
                <div style={{color:'var(--text-muted)',fontSize:'0.78rem'}}>{k.birim}</div>
                <div className="form-group" style={{margin:0,width:100}}>
                  <input className="form-input" type="number" value={k.birim_fiyat} onChange={e=>kalemGuncelle(i,'birim_fiyat',e.target.value)} />
                </div>
                <div style={{fontFamily:'var(--font-ui)',fontWeight:800,color:'#10B981',minWidth:80,textAlign:'right'}}>{TL(parseFloat(k.miktar)*parseFloat(k.birim_fiyat||0))}</div>
                <button className="btn btn-ghost btn-sm" style={{color:'#EF4444'}} onClick={()=>kalemSil(i)}>✕</button>
              </div>
            ))}
            <div style={{padding:'10px 14px',background:'var(--bg-elevated)',fontFamily:'var(--font-ui)',fontWeight:900,color:'var(--blue)',textAlign:'right',fontSize:'1.1rem'}}>
              Toplam: {TL(toplam)}
            </div>
          </div>
        )}

        <div style={{display:'flex',justifyContent:'flex-end',gap:10}}>
          <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving||!seciliKalemler.length}>
            {saving?<div className="spinner" style={{width:16,height:16}}/>:'💾 Satışı Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function MateryalSatisPage() {
  const [satislar, setSatislar]     = useState([]);
  const [stokKalemleri, setStokKalemleri] = useState([]);
  const [ogrenciler, setOgrenciler] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showModal, setShowModal]   = useState(false);
  const [odemeId, setOdemeId]       = useState(null);
  const [odemeForm, setOdemeForm]   = useState({ tutar:'', odeme_yontemi:'nakit' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await axios.get('/muhasebe/materyal-satis');
      if (r.data.success) setSatislar(r.data.data);
    } catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    axios.get('/muhasebe/stok').then(r=>{if(r.data.success)setStokKalemleri(r.data.data||[]);}).catch(()=>{});
    axios.get('/ogrenciler').then(r=>{if(r.data.success)setOgrenciler(r.data.data||[]);}).catch(()=>{});
  }, []);

  const handleSave = async (form) => {
    try {
      await axios.post('/muhasebe/materyal-satis', form);
      toast.success('Satış kaydedildi!');
      setShowModal(false); load();
    } catch (e) { toast.error(e.response?.data?.message||'Hata'); }
  };

  const handleOdeme = async () => {
    try {
      await axios.put(`/muhasebe/materyal-satis/${odemeId}/odeme`, odemeForm);
      toast.success('Ödeme kaydedildi');
      setOdemeId(null); load();
    } catch { toast.error('Hata'); }
  };

  const DURUM_RENK = { odenmedi:'#EF4444', kismi:'#F59E0B', odendi:'#10B981' };
  const DURUM_ETIKET = { odenmedi:'❌ Ödenmedi', kismi:'⚡ Kısmi', odendi:'✅ Ödendi' };

  return (
    <div style={{display:'flex',flexDirection:'column',gap:20}}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{fontFamily:'var(--font-ui)',fontWeight:900}}>🛒 Materyal Satışı</h2>
          <div className="section-subtitle">Kitap seti ve materyal satış takibi</div>
        </div>
        <button className="btn btn-primary" onClick={()=>setShowModal(true)}>+ Yeni Satış</button>
      </div>

      <div className="card animate-fadeInUp" style={{padding:0}}>
        {loading ? <div className="page-loader" style={{minHeight:200}}><div className="spinner"/></div>
        : satislar.length===0 ? <div className="empty-state" style={{padding:56}}><div style={{fontSize:'3rem'}}>🛒</div><h3>Satış kaydı yok</h3></div>
        : (
          <div className="table-container">
            <table className="table">
              <thead><tr><th>Öğrenci</th><th>Tarih</th><th>Yöntem</th><th style={{textAlign:'right'}}>Toplam</th><th style={{textAlign:'right'}}>Ödenen</th><th style={{textAlign:'right'}}>Kalan</th><th>Durum</th><th></th></tr></thead>
              <tbody>
                {satislar.map((s,i)=>(
                  <tr key={i} style={{borderLeft:`4px solid ${DURUM_RENK[s.odeme_durumu]||'#94A3B8'}`}}>
                    <td>
                      <div style={{fontWeight:700}}>{s.ad} {s.soyad}</div>
                      <div style={{fontSize:'0.72rem',color:'var(--text-muted)'}}>{s.sinif_adi}</div>
                    </td>
                    <td style={{fontSize:'0.82rem'}}>{new Date(s.created_at).toLocaleDateString('tr-TR')}</td>
                    <td style={{fontSize:'0.78rem',color:'var(--text-muted)'}}>{s.odeme_yontemi}</td>
                    <td style={{textAlign:'right',fontFamily:'var(--font-ui)',fontWeight:800}}>{TL(s.toplam_tutar)}</td>
                    <td style={{textAlign:'right',color:'#10B981',fontWeight:700}}>{TL(s.odenen_tutar)}</td>
                    <td style={{textAlign:'right',color:s.kalan_tutar>0?'#EF4444':'#10B981',fontWeight:700}}>{TL(s.kalan_tutar)}</td>
                    <td><span className="badge" style={{background:(DURUM_RENK[s.odeme_durumu]||'#94A3B8')+'22',color:DURUM_RENK[s.odeme_durumu]||'#94A3B8'}}>{DURUM_ETIKET[s.odeme_durumu]}</span></td>
                    <td>
                      {s.odeme_durumu!=='odendi' && (
                        <button className="btn btn-sm" style={{background:'#10B981',color:'white',border:'none'}}
                          onClick={()=>{setOdemeId(s.id);setOdemeForm({tutar:s.kalan_tutar,odeme_yontemi:'nakit'});}}>
                          💳 Tahsil
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Tahsilat mini modal */}
      {odemeId && (
        <div className="modal-backdrop" onClick={()=>setOdemeId(null)}>
          <div className="modal" style={{maxWidth:380}} onClick={e=>e.stopPropagation()}>
            <div className="modal-header"><div className="modal-title">💳 Ödeme Al</div><button className="modal-close" onClick={()=>setOdemeId(null)}>✕</button></div>
            <div style={{display:'flex',flexDirection:'column',gap:12}}>
              <div className="form-group"><label className="form-label">Tutar</label>
                <input className="form-input" type="number" value={odemeForm.tutar} onChange={e=>setOdemeForm(f=>({...f,tutar:e.target.value}))} /></div>
              <div className="form-group"><label className="form-label">Yöntem</label>
                <select className="form-input" value={odemeForm.odeme_yontemi} onChange={e=>setOdemeForm(f=>({...f,odeme_yontemi:e.target.value}))}>
                  <option value="nakit">Nakit</option><option value="kredi_karti">Kredi Kartı</option><option value="banka_havalesi">Banka Havalesi</option>
                </select>
              </div>
            </div>
            <div style={{display:'flex',justifyContent:'flex-end',gap:10,marginTop:16}}>
              <button className="btn btn-secondary" onClick={()=>setOdemeId(null)}>İptal</button>
              <button className="btn btn-primary" onClick={handleOdeme}>✅ Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {showModal && <SatisModal stokKalemleri={stokKalemleri} ogrenciler={ogrenciler} onSave={handleSave} onClose={()=>setShowModal(false)} />}
    </div>
  );
}
